export function isMac(): boolean {
  return typeof navigator !== "undefined"
    ? /Mac/.test(navigator.platform)
    : false;
}
